module.exports = __webpack_public_path__ + "img/3C.c8b2ab03.png";